import { useContext, createContext } from 'react';
import { configurationContextDefaultValues } from "../constants";
export var configurationContext = /*#__PURE__*/createContext(configurationContextDefaultValues);
export var ConfigurationProvider = configurationContext.Provider;
export var useConfiguration = function useConfiguration() {
  return useContext(configurationContext);
};